import { render, staticRenderFns } from "./tab-tertiary.vue?vue&type=template&id=f8f4a8fc&scoped=true&"
import script from "./tab-tertiary.vue?vue&type=script&lang=js&"
export * from "./tab-tertiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f4a8fc",
  null
  
)

export default component.exports